import React from 'react';
import { IconButton, Typography, TableCell, Tooltip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FONT_BODY, COLORS, TYPE, RADIUS } from '../styles/recruiterTheme';

const navSx = {
  width: 32, height: 32, borderRadius: `${RADIUS.sm}px`,
  border: `1px solid ${COLORS.border}`, color: COLORS.primary,
  '&:hover': { background: COLORS.surfaceTint },
  '&.Mui-disabled': { color: COLORS.faint, borderColor: COLORS.border },
};
const textSx = { fontFamily: FONT_BODY, fontSize: TYPE.small, color: COLORS.muted, fontVariantNumeric: 'tabular-nums' };

const Pagination = ({ itemsPerPage, currentPage, totalPages, handlePrevPage, handleNextPage }) => {
  const total = Math.max(totalPages || 1, 1);
  return (
    <TableCell
      colSpan={6}
      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, padding: '12px 16px', borderBottom: 'none' }}
    >
      <Typography component="span" sx={textSx}>{`${itemsPerPage} per page`}</Typography>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Tooltip title="Previous page">
          <span>
            <IconButton size="small" sx={navSx} onClick={handlePrevPage} disabled={currentPage === 1} aria-label="Previous page">
              <ChevronLeftIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        <Typography component="span" sx={{ ...textSx, color: COLORS.ink, fontWeight: 600, minWidth: 80, textAlign: 'center' }}>
          {`Page ${currentPage} of ${total}`}
        </Typography>
        <Tooltip title="Next page">
          <span>
            <IconButton size="small" sx={navSx} onClick={handleNextPage} disabled={currentPage === totalPages} aria-label="Next page">
              <ChevronRightIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    </TableCell>
  );
};

export default Pagination;
